import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getMmsEnabled = (configuration: IConfigurationParams[]): boolean => {
  const mmsParams = configuration.find((
    params,
  ) => params.name === ConfigurationNames.mms);

  return mmsParams ? JSON.parse(mmsParams.configuration).enabled : false;
};
